import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  CANCEL,
  CATEGORY_LIST,
  CLOSE_FORM,
  LIST_LOADING,
  SAVE,
  SESSION_FORM,
  SESSION_TEMPLATE_FORM,
  SESSION_TEMP_CONSTANTS,
  SESSION_VALIDATORS,
  SESSION_TEMPLATES_ACCESS
} from "../../constants/SessionTemplateConstants";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import { SessionTemplateService } from "../../services/SessionTemplateService";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { SessionTemplate } from "../../models/SessionTemplate";
import { Response } from "@/shared/models/Response";
import { ListService } from "@/modules/List/services/ListService";
import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Utils } from "@/shared/utils/utils";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { MULTIMEDIA_CLEANED } from "@/shared/components/MultimediaManager/constants/MultimediaManagerConstants";
import MultimediaManager from "@/shared/components/MultimediaManager/MultimediaManager.vue";
import lodash from "lodash";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { AxiosError } from "axios";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { SessionForm } from "../../models/SessionForm.model";

@Component({
  name: "SaveSessionTemplate",
  components: {
    ModalTemplate,
    MultimediaManager,
    DynamicSelect
  }
})
export default class SaveSessionTemplate extends Vue {
  @Inject() sessionTemplateService!: SessionTemplateService;
  @Inject() listService!: ListService;

  @Prop() sessionToEdit?: string;
  @Prop() isModal!: boolean;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  SESSION_FORM = SESSION_FORM;
  CANCEL = CANCEL;
  SAVE = SAVE;
  SESSION_TEMPLATE_FORM = SESSION_TEMPLATE_FORM;

  pageTitle = SESSION_TEMP_CONSTANTS.PAGE_TITLE_CREATE;
  SESSION_NAME = SESSION_TEMP_CONSTANTS.LABEL.NAME;
  SESSION_URL = SESSION_TEMP_CONSTANTS.LABEL.URL_PLAYBOOK;
  SESSION_STATE = FORM_CONSTANTS.LABEL.STATE;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  LIST_LOADING = LIST_LOADING;

  blankSpaceField = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredArrayFields = [FORM_VALIDATORS.REQUIRED_ARRAY];
  maxLength = [SESSION_VALIDATORS.MAX_LENGTH];
  urlPattern = [FORM_VALIDATORS.URL_PATTERN];
  sessionNameRules = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR,
    FORM_VALIDATORS.MAX_SESSION_NAME
  ];

  sessionTempform = false;
  sessionUrl = "";
  sessionTemplateId = "";
  isEditing = false;
  modalDialog = false;
  modalText = "";
  modalTitle = "";
  sessionTemplate!: SessionTemplate;
  categoriesList = [{ id: "", name: "" }];
  categories: string[] = [];
  errorsName: string[] = [];

  sessionCategorySelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SESSION_FORM.CATEGORY,
    hint: this.SESSION_FORM.SELECT_CATEGORY,
    persistenthint: true,
    hideDetails: false,
    rules: this.requiredArrayFields
  };

  sessionForm: SessionForm = {
    sessionName: "",
    categoriesList: [],
    state: false,
    multimediaFile: lodash.cloneDeep(MULTIMEDIA_CLEANED)
  };

  editComparationStr = "";
  invalidEdit = false;

  mounted() {
    this.getCategorySessionList();
    if (this.sessionToEdit) {
      this.listenSessionToEdit();
    }
    this.goToStart(SESSION_TEMPLATE_FORM);
  }

  @Watch("sessionToEdit")
  listenSessionToEdit() {
    if (this.sessionToEdit) {
      this.sessionTemplateId = this.sessionToEdit;
      this.getSessionTemplateById();
      this.pageTitle = SESSION_TEMP_CONSTANTS.PAGE_TITLE_EDIT;
      this.isEditing = true;
      return;
    }
    this.isEditing = false;
    this.cleanForm();
  }

  @Watch("categoriesList")
  updateCategory() {
    this.sessionForm.categoriesList = [...this.categoriesList];
  }

  @Watch("sessionForm", { deep: true })
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify(this.sessionForm) === this.editComparationStr;
    }
  }

  cleanForm() {
    this.sessionForm.sessionName = "";
    this.sessionUrl = "";
    this.categories = [];
    this.sessionForm.state = true;
    (this.$refs.form as Vue & {
      resetValidation: () => void;
    }).resetValidation();
    this.sessionForm.multimediaFile = lodash.cloneDeep(MULTIMEDIA_CLEANED);
  }

  async getSessionTemplateById() {
    try {
      const response = await this.sessionTemplateService.getSessionTemplateById(
        this.sessionTemplateId
      );

      if (response.code === Http.Found && response.data) {
        this.sessionTemplate = response.data;
        this.fillSessionForm();
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SESSION_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getCategorySessionList() {
    const responseCategories = await this.getListDataById(CATEGORY_LIST);
    if (responseCategories !== undefined) {
      this.sessionCategorySelectConfig.listAll = responseCategories.map(
        item => {
          return { id: item, name: item };
        }
      );
    }
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: string[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(item => listDataList.push(item.title));
        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return undefined;
    }
  }

  fillSessionForm() {
    this.sessionForm.sessionName = this.sessionTemplate.name;
    this.categoriesList = this.sessionTemplate.categories.map(item => {
      return { id: item, name: item };
    });

    this.sessionForm.state =
      this.sessionTemplate.state === FORM_CONSTANTS.STATE.ACTIVE ? true : false;
    this.sessionForm.multimediaFile = this.sessionTemplate.multimedia;
    this.editComparationStr = JSON.stringify({
      ...this.sessionForm,
      categoriesList: this.categoriesList
    });
  }

  confirmDialog(operation: string) {
    if (operation === SAVE) {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    } else if (operation === CANCEL) {
      this.modalTitle = FORM_MESSAGES.CANCEL_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    }

    this.modalDialog = true;
  }

  async handleModalAccept() {
    this.modalDialog = false;

    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveSessionTemplate();
    } else if (this.modalTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.cleanForm();
      this.$emit(CLOSE_FORM);
    }
  }

  handleModalCancel() {
    this.modalDialog = false;
  }

  async saveSessionTemplate() {
    try {
      const sessionToSave: SessionTemplate = {
        name: this.sessionForm.sessionName,
        categories: this.sessionForm.categoriesList.map(item => item.id),
        state: this.sessionForm.state
          ? FORM_CONSTANTS.STATE.ACTIVE
          : FORM_CONSTANTS.STATE.INACTIVE,
        multimedia: { _key: this.sessionForm.multimediaFile?._key ?? "" }
      };

      let response: Response<string | void>;

      if (this.isEditing) {
        sessionToSave.dateChanged = Date.now();
        sessionToSave.dateCreated = this.sessionTemplate.dateCreated;
        sessionToSave.createdBy = this.sessionTemplate.createdBy;
        sessionToSave.changedBy = localStorage.getItem(FORM_CONSTANTS.UID_TEXT);

        response = await this.sessionTemplateService.updateSessionTemplate(
          this.sessionTemplateId,
          sessionToSave
        );
      } else {
        sessionToSave.dateCreated = Date.now();
        sessionToSave.createdBy = localStorage.getItem(FORM_CONSTANTS.UID_TEXT);
        sessionToSave.name = sessionToSave.name.trim();

        const existSession = await this.sessionTemplateService.checkIfSessionNameExists(
          this.sessionForm.sessionName
        );

        if (existSession.code !== Http.Found) {
          response = await this.sessionTemplateService.addSessionTemplate(
            sessionToSave
          );
        } else {
          Snackbar.popWarning(SESSION_TEMP_CONSTANTS.MESSAGE.NAME_EXISTS);
          return;
        }
      }

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
        this.cleanForm();
        this.$emit(CLOSE_FORM);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof SESSION_TEMPLATES_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST} ${SESSION_TEMPLATES_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return;
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  getFile(fileSelected: MultimediaSelected) {
    this.sessionForm.multimediaFile = fileSelected;
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.SESSION_TEMPLATE,
      this.sessionForm.sessionName
    );
  }
}
